module.exports = __webpack_public_path__ + "static/media/boys-in-class.9c99f5d2.jpeg";